// @flow
import React from 'react';
import styled from 'styled-components';
import { usePagination, useTable } from 'react-table';
import { Button, Text, TextInput } from '..';
import { colors } from '../../../stylesheets';
import ListHeader from './ListHeader';
import ListFooter from './ListFooter';
import CustomModal from '../Modal/Modal';
import { Col, Row } from 'reactstrap';
import { useImmer } from 'use-immer';

type Props = {
  columns: Array,
  data: Array,
  className?: string,
  buttonTitle?: string,
  buttonOnClick?: Function,
  buttonIconName?: string,
  headerLogo?: Object,
  iconNameArray?: Array,
  iconOnClick?: Function,
  rowClassName?: Function,
};

const StyledTable = styled.div`
  table {
    width: 100%;

    thead {
      th {
        p {
          display: flex;
          justify-content: center;
        }

        :last-child {
          p {
            justify-content: flex-end;
          }
        }

        :first-child {
          padding-left: 5%;

          p {
            justify-content: flex-start;
          }
        }

        /* text-align: center; */
        color: #ef5789;
        padding: 5px 10px;
      }
    }

    tbody {
      td {
        p {
          display: flex;
          justify-content: center;
        }

        :last-child {
          border-radius: 12px 0 0 12px;

          p {
            justify-content: flex-end;
          }
        }

        :first-child {
          border-radius: 0 12px 12px 0;

          p {
            justify-content: flex-start;
          }
        }
      }

      tr:hover {
        transition: all 0.2s ease;
        background: ${colors.palePrimary};
      }
    }

    td {
      padding: 10px 5px;
    }
  }
`;


const DefaultFiltersComponent = () => {
  return (<></>)
}
 
const List = (props: Props) => {
  const {
    noHeader,
    hasPagination,
    buttonTitle,
    buttonOnClick,
    buttonIconName,
    headerLogo,
    iconNameArray,
    iconOnClick,
    columns,
    data,
    className,
    rowClassName,
    onSearch = () => null,
    FiltersComponent=DefaultFiltersComponent,
    filtersProps={},
    onSelectFilters,
  } = props;
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    rows,
    prepareRow,
    // The rest of these things are for pagination
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
    },
    usePagination
  );

  const [searchState, setSearchState] = React.useState(false);
  const [filtersState, setFiltersState] = React.useState(false);
  const [searchText, setSearchText] = React.useState("");
  const [filtersData, setFiltersData] = useImmer({});

  const handleSearch = (e) => {

  }

  return (
    <>
    <StyledTable className={className}>
      {noHeader ? null : (
        <ListHeader
          buttonTitle={buttonTitle}
          buttonOnClick={buttonOnClick}
          buttonIconName={buttonIconName}
          headerLogo={headerLogo}
          iconNameArray={iconNameArray}
          iconOnClick={(iconID) => {
              if (iconID === "search") {
                setSearchState(true);
              }

              if (iconID === "filter") {
                setFiltersState(true);
              }
            iconOnClick(iconID)
          }}
        />
      )}
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()} >
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()} >
                  <Text type="div" size="xs" className="text-center w-100">
                    {column.render('Header')}
                  </Text>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {(hasPagination ? page : rows).map((row, i) => {
            prepareRow(row);
            return (
              <tr
                {...row.getRowProps()}
                className={`cursor-pointer ${
                  rowClassName && rowClassName(row.original)
                }`}
              >
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>
                      <Text className="m-0 h-100 text-center w-100" type="div" size="md">
                        {cell.render('Cell')}
                      </Text>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      {hasPagination ? (
        <ListFooter
          canNextPage={canNextPage}
          nextPage={nextPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          pageIndex={pageIndex}
          gotoPage={gotoPage}
          pageCount={pageCount}
          pageSize={pageSize}
          setPageSize={setPageSize}
        />
      ) : null}
    </StyledTable>
    <CustomModal toggle={() => setSearchState(!searchState)} isOpen={searchState} title="جستجو در جدول">
      <div className="d-flex justify-content-center align-items-center flex-column">
          <TextInput onChange={(e) => setSearchText(e.target?.value)} value={searchText} placeholder="متن مورد نظر را وارد کنید..." className="w-75 mx-4 my-3" />
          <Button onClick={() => {
            onSearch(searchText);
            setSearchState(false);
          }}>جستجو</Button>
      </div>
    </CustomModal>
    <CustomModal 
      toggle={() => setFiltersState(!filtersState)}
      isOpen={filtersState}
      title="انتخاب فیلترها"
      className="modal-medium"
      iconColor={"white"}
      >
      <div className="d-flex justify-content-center align-items-center flex-column mt-4 mb-1">
          <FiltersComponent 
            onSubmitFilter={({key, value}) => {
              setFiltersData(draft => {
                if (value === "DELETE") {
                  delete draft[key];
                }  else {
                  draft[key] = value;
                }
                
                return draft;
              })
            }}
            {...filtersProps}
          a/>
          <div className="d-flex justify-content-center">
              <Button onClick={() => {
                onSelectFilters(filtersData);
                setFiltersState(false);
              }}>ثبت و جستجو</Button>
          </div>
      </div>
    </CustomModal>
    </>
  );
};

List.defaultProps = {};

export default List;
